import { MatSerNumber, NotificationIdentifier } from '@evorait/pace-core';
import { createAction, props } from '@ngrx/store';
import { FormList } from '../../types/form-list';
import { FormsConstants } from '../../types/forms-constants';

export const loadFormList = createAction(
    '[Forms] Load form list',
    props<{
        mainEquipment: MatSerNumber;
        equipmentNr: string;
        notification: NotificationIdentifier;
        fromCache: boolean;
    }>(),
);
export const loadFormListSuccess = createAction(
    '[Forms] Form list successfully loaded',
    props<{ formList: FormList }>(),
);
export const loadFormListError = createAction(
    '[Forms] Error loading form list',
    props<{ notification: NotificationIdentifier }>(),
);

export const loadEquipmentSet = createAction(
    '[Forms] Load equipmentset',
    props<{ notificationIdentifier: NotificationIdentifier; mainEquipment: MatSerNumber }>(),
);

export const loadEquipmentSetSuccess = createAction(
    '[Forms] Equipmentset successfully loaded',
    props<{ notificationIdentifier: NotificationIdentifier; equipmentSet: MatSerNumber[] }>(),
);

export const loadEquipmentSetError = createAction(
    '[Forms] Error loading equipmentset',
    props<{ notificationIdentifier: NotificationIdentifier }>(),
);

export const cleanupFormList = createAction(
    '[Forms] Cleanup saved form list data',
    props<{
        formList: FormList;
    }>(),
);

export const cleanupFormListSuccess = createAction(
    '[Forms] Successfully cleaned up saved form list data for notification',
    props<{
        notification: NotificationIdentifier;
    }>(),
);

export const setSelectedLanguageInFormList = createAction(
    '[Forms] set selected language',
    props<{
        notification: NotificationIdentifier;
        selectedLanguage: FormsConstants.FORM_LANGUAGES;
    }>(),
);
